import getByMode from '../../../utils/getByMode';

import chuck from './chuck';
import mandi from './mandi';

export default getByMode({
  chuck,
  mandi,
});

